/** Hardcoded type sent on create/update segment group. */
export const SEGMENT_GROUP_TYPE_ID = 'GENERAL';

export const SEGMENT_ASSOC_TYPE = {
  EXCLUDED: 'EXCLUDED',
};

export const SEGMENT_ASSOC_ACTION = {
  ASSOCIATE: 'ASSOCIATE',
  DEASSOCIATE: 'DEASSOCIATE',
};
